import React, { useMemo } from "react";
import onDateEdit from "../util/forms/onDateEdit";
import { InputAdornment } from "@mui/material";
import { DesktopDatePicker, MobileDatePicker } from "@mui/x-date-pickers";
import { SlideUpModalInput } from "../views/comparison_views/molecules/SlideUpModalInput";

const OpenPickerIcon = React.memo(() => (
  <img className="date-picker-icon" src="/img/svg_icons/Calendar.svg" />
));

export const SlideUpDatePicker = ({
  value,
  component,
  name,
  label,
  helperText,
  error,
}) => {
  const endAdornment = useMemo(
    () => (
      <InputAdornment
        className="date-picker-icon-mobile-wrapper date-picker-slider-wrapper"
        position="start"
      >
        <img
          className="date-picker-icon .slide-up-date-picker-icon"
          src="/img/svg_icons/Calendar.svg"
        />
      </InputAdornment>
    ),
    []
  );

  return (
    <>
      <DesktopDatePicker
        disablePast
        className="desktop-date-picker slide-up-date-picker"
        value={value}
        onChange={(dayjsDate) => {
          onDateEdit(dayjsDate, name, component);
        }}
        components={{
          OpenPickerIcon,
        }}
        renderInput={(params) => (
          <SlideUpModalInput
            {...params}
            label={label}
            inputProps={{
              ...params.inputProps,
              placeholder: "mm / dd / yyyy",
            }}
            helperText={helperText}
            error={error}
          />
        )}
        name="date"
      />
      <MobileDatePicker
        value={value}
        className="mobile-date-picker slide-up-date-picker"
        disablePast
        disableMaskedInput={false}
        onChange={(dayjsDate) => {
          onDateEdit(dayjsDate, name, component);
        }}
        components={{
          OpenPickerIcon: () => (
            <img
              className="date-picker-icon"
              src="/img/svg_icons/Calendar.svg"
            />
          ),
        }}
        renderInput={(params) => (
          <SlideUpModalInput
            {...params}
            label={label}
            inputProps={{
              ...params.inputProps,
              placeholder: "mm / dd / yyyy",
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment,
            }}
            helperText={helperText}
            error={error}
          />
        )}
        name="date"
      />
    </>
  );
};
